import { FormHelperText, Switch, SwitchProps } from '@mui/material';
import { colors } from 'common/constants';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
type BaseSwitchProps = SwitchProps & {
    name: string;
};
const BaseSwitch: React.FC<BaseSwitchProps> = ({ name, ...props }) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <>
                    <Switch
                        {...field}
                        checked={field.value || false}
                        onChange={(e) => {
                            field.onChange(e.target.checked);
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        {...props}
                    />
                    {fieldState.error && (
                        <FormHelperText
                            sx={{
                                fontSize: '14px',
                                marginLeft: 0,
                                color: `${colors.textError} !important`,
                                fontWeight: '400',
                            }}
                        >
                            {fieldState.error?.message}
                        </FormHelperText>
                    )}
                </>
            )}
        />
    );
};

export default BaseSwitch;
